import { Header } from '@/components/Header';
import { ActionBar } from '@/dashboards/ModelContributions/components/ActionBar';
import { useModelContributionContext } from '@/dashboards/ModelContributions/hooks';

export const ModelContributionHeader = () => {
    const { search } = useModelContributionContext();
    return (
        <Header
            className="pb-6 px-8 lg:px-16 pt-6"
            title="Model Contributions"
            tooltip="Explore what factors moved your KPI. Take a broad look at the entire period or narrow your focus to specific dates or variables for targeted insights."
            subtitle={`by ${search.modelBreakdown}`}
            sticky
        >
            <ActionBar />
        </Header>
    );
};
